
export default function Index(props:{
    title:string,
    value:string,
    icon:any
}){
    return <div className="rTokenRate-item">
        <div className='left'>
            <img src={props.icon} />
            {props.title}
        </div>
        <div className='right'>
            {props.value}
        </div>
    </div>
}